import React from 'react';
import PageBanner from '../components/PageBanner';
import WhyChoose from '../components/sections/WhyChoose';
import GetInTouch from '../components/sections/GetInTouch';
import { welcomeImages, aboutImage } from '../mock';
import { Target, Eye, Heart } from 'lucide-react';

const About = () => {
  return (
    <>
      <PageBanner title="About Us" subtitle="Warmth, skill and reliability — brought together for the people and providers who rely on us." variant="split" image="/generated/about-banner.png" />

      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
          <div className="relative">
            <img src={aboutImage} alt="Our care" className="rounded-3xl shadow-lg w-full h-[420px] object-cover" />
            <div className="absolute -bottom-6 -right-6 w-40 h-40 text-brand-orange/25 dots-pattern hidden md:block" />
          </div>
          <div>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-slate-900 mb-6">A companion you can count on</h2>
            <p className="font-body text-slate-600 leading-relaxed mb-5">
              Trusted Companion Health Care Limited helps people across Ireland stay safe, comfortable and independent in the place that matters most — their own home.
            </p>
            <p className="font-body text-slate-600 leading-relaxed">
              Whether it's a few hours of friendly companionship each week or complex daily care, we shape our support around the individual and the people who love them. And for the care homes and providers we partner with, we supply skilled, Garda-vetted professionals they can genuinely rely on.
            </p>
          </div>
        </div>
      </section>

      <section className="pb-20 lg:pb-28 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-3 gap-6">
          {[
            { icon: Target, title: 'Our Mission', desc: 'To deliver approachable, high-quality care that helps people live life their way — with dignity and independence intact.' },
            { icon: Eye, title: 'Our Vision', desc: 'To be the care and staffing partner families and providers across Ireland turn to first, and trust the most.' },
            { icon: Heart, title: 'Our Values', desc: 'Compassion, honesty, professionalism and respect guide every visit, every decision and every relationship.' },
          ].map((c, i) => (
            <div key={i} className="bg-brand-blue-light rounded-3xl p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center mb-5"><c.icon className="w-7 h-7 text-brand-orange" /></div>
              <h3 className="font-heading font-semibold text-xl text-slate-900 mb-3">{c.title}</h3>
              <p className="font-body text-slate-600 text-sm leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <WhyChoose />
      <GetInTouch />
    </>
  );
};

export default About;
